import { styled, Typography } from '@mui/material';
import React, { useMemo } from 'react';

import { getTileColor } from './rubricUtils';

const RatingTileContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '3px',
  marginRight: '12px',
});

type RatingTileProps = {
  filled: boolean;
  color: string;
};

const RatingTile = styled('div')<RatingTileProps>(({ filled, color }) => ({
  width: '28px',
  height: '8px',
  borderRadius: '100px',
  backgroundColor: filled ? color : '#E8ECEF',
}));

interface RubricOverallRatingProps {
  rating: number;
  rubricType: string;
}

const RubricOverallRating: React.FC<RubricOverallRatingProps> = ({ rating, rubricType }) => {
  const roundedRating = Math.round(rating);
  const maxRating = useMemo(() => {
    if (rubricType === 'LMH') return 3;
    return Number(rubricType);
  }, [rubricType]);

  const isFilled = (index: number) => {
    return roundedRating >= index + 1;
  };

  const scaleValues = useMemo(
    () =>
      rubricType === 'LMH'
        ? [0, 1, 2]
        : (() => {
            const values = [];
            for (let i = 0; i < Number(rubricType); i++) {
              values.push(i);
            }
            return values;
          })(),
    [rubricType]
  );

  if (!rubricType) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <RatingTileContainer>
        {scaleValues.map((_, index) => (
          <RatingTile
            key={index}
            filled={isFilled(index)}
            color={getTileColor(index, rating, maxRating)}
          />
        ))}
      </RatingTileContainer>
      <Typography sx={{ fontSize: '14px', color: '#2A2C2F' }}>{rating.toFixed(1)}</Typography>
    </div>
  );
};

export default RubricOverallRating;
